module.exports = __webpack_public_path__ + "img/ewm_ms_android.0f102542.png";